import React, { useEffect, useState } from "react";
import ReactHexGridLayout from "./component/react-grid-layout";
import Button from "@mui/material/Button";
import { HexagonBackground } from "./component/hexagon-background";
import { ConnectWalletModal } from "./component/connect-wallet-modal";
import { ShareModal } from "./component/share-modal";
import { ConnectedAccount } from "./component/connected-account";
import eathlogo from "../../images/logo/earth-logo.png";
import eathlogoDark from "../../images/logo/earth-logo-dark.png";
import home2 from "../../images/sidebar/blackhome2.png";
import nft2 from "../../images/sidebar/blacknft2.png";
import dfi2 from "../../images/sidebar/blackdfi2.png";
import treaury2 from "../../images/sidebar/blacktreaury2.png";
import bigmove2 from "../../images/sidebar/blackbigmove2.png";
import ens2 from "../../images/sidebar/blackens2.png";

import VerlegendsImg from "../../images/legend/atlas_legend_vertical.png";
import harztallegendsImg from "../../images/legend/atlas_legend_harizatal.png";
import horizontalSvgLegendImage from "../../images/legend/atlas_legend_horizontal.svg";
import loading from "../../images/loader.gif";
import Snackbar from "@mui/material/Snackbar";
import shareicon from "../../images/share-icon.svg";
import legendsimg1 from "../../images/ledgent1.png";
import legendsimg2 from "../../images/ledgent-2.png";
import legendsimg3 from "../../images/ledgent-3.png";
import legendsDarkimg1 from "../../images/dark-ledgent.png";
import legendsDarkimg2 from "../../images/dark-ledgent-2.png";
import legendsDarkimg3 from "../../images/dark-ledgent-3.png";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Filters } from "./index.service";

const DashboardContainer = ({
  onClickConnectWallet,
  closeConnectWalletModal,
  onClickMetaMask,
  onClickWalletConnect,
  showConnectModal,
  showShareModal,
  onClickShareHex,
  closeShareModal,
  onClickDisconnect,
  accountConnected,
  address,
  hexData,
  isValidNetwork,
  isLoading,
  onClickHex,
  twitterImageUrl,
  onChangeFilter,
  selectedFilter,
}) => {
  const [isLightTheme, setIsLightTheme] = useState(true);
  const [headerWidth, setheaderWidth] = useState(200);
  const onClickLightTheme = () => {
    document.body.className = "light-theme";
    setIsLightTheme(true);
  };
  const onClickDarkTheme = () => {
    document.body.className = "dark-theme";
    setIsLightTheme(false);
  };
  useEffect(() => {
    let menu = document.getElementsByClassName("nav-menu")[0];
    let width = menu.clientWidth;
    setheaderWidth(width);
    console.log({ width });
  });

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [isActive, setIsActive] = useState(false);

  const handleClick = (event) => {
    // 👇️ toggle isActive state on click
    setIsActive((current) => !current);
  };

  return (
    <React.Fragment>
      {isLoading && (
        <div class="divLoader">
          <p>Generating Map...</p>
          <img src={loading} width="50px" />
        </div>
      )}
      <header className={`${accountConnected == "" ? "" : "connected"}`}>
        <aside className="earth-logo">
          <a id="site-title" href="#">
            <img src={eathlogo} className="earthlogolight" />
            <img src={eathlogoDark} className="earthlogoDark" />
          </a>
          {accountConnected && (
            <p>
              <span className="nameid">{`${
                hexData?.dotEarthHandle ?? ""
              }`}</span>
              <span className="earthname">.earth.eth</span>
            </p>
          )}
        </aside>
        <aside className="nav-menu">
          {!accountConnected && (
            <ul>
              <li>
                {/* <a href="" className="active" onClick={onClickConnectWallet}>
                  <span>Connect Your wallet</span>
                </a> */}
              </li>
            </ul>
          )}
          {accountConnected && (
            <>
              <div>
                <Button
                  variant="contained"
                  onClick={onClickShareHex}
                  className="share-button"
                >
                  <img src={shareicon} />
                </Button>
              </div>
              <ConnectedAccount
                onClickDisconnect={onClickDisconnect}
                address={address}
                isValidNetwork={isValidNetwork}
              />
            </>
          )}
        </aside>
      </header>
      <section
        className={`page-cont ${
          accountConnected == "" ? "" : "connected-wallet"
        }`}
      >
        {accountConnected ? (
          <div className="mapwrapper">
            <div className="sidebar">
              <ul>
                <li
                  className={selectedFilter === Filters.home ? "active" : ""}
                  onClick={() => onChangeFilter(Filters.home)}
                >
                  <span className="sidebarIcon">
                    <img src={home2} />
                  </span>
                  {/* <img src={homeLocation} /> */}
                  Home
                </li>
                <li
                  className={selectedFilter === Filters.nft ? "active" : ""}
                  onClick={() => onChangeFilter(Filters.nft)}
                >
                  <span className="sidebarIcon">
                    <img src={nft2} />
                  </span>
                  {/* <img src={palette} /> */}
                  NFT
                </li>
                <li
                  className={selectedFilter === Filters.ens ? "active" : ""}
                  onClick={() => onChangeFilter(Filters.ens)}
                >
                  <span className="sidebarIcon">
                    <img src={ens2} />
                  </span>
                  {/* <img src={ENS} /> */}
                  ENS
                </li>
                <li
                  className={selectedFilter === Filters.defi ? "active" : ""}
                  onClick={() => onChangeFilter(Filters.defi)}
                >
                  <span className="sidebarIcon">
                    <img src={dfi2} />
                  </span>
                  {/* <img src={bank} /> */}
                  Defi
                </li>
                <li
                  className={
                    selectedFilter === Filters.treasury ? "active" : ""
                  }
                  onClick={() => onChangeFilter(Filters.treasury)}
                >
                  <span className="sidebarIcon">
                    <img src={treaury2} />
                  </span>
                  {/* <img src={coins} /> */}
                  Treasury
                </li>
                <li
                  className={
                    selectedFilter === Filters.bigMoves ? "active" : ""
                  }
                  onClick={() => onChangeFilter(Filters.bigMoves)}
                >
                  <span className="sidebarIcon">
                    <img src={bigmove2} />
                  </span>
                  {/* <img src={arrow} /> */}
                  Big Moves
                </li>
              </ul>
            </div>
            <ReactHexGridLayout
              hexData={hexData}
              onClickHex={onClickHex}
              onChangeFilter={onChangeFilter}
              selectedFilter={selectedFilter}
            />
          </div>
        ) : (
          <div className="atlas-block-content">
            <HexagonBackground />
            <h1>ATLAS. </h1>
            <p className="sqsrte-large">Map your Web3 Presence. </p>
            <aside className="primary-btn">
              <Button variant="contained" onClick={onClickConnectWallet}>
                <span>CONNECT YOUR WALLET</span>
              </Button>
            </aside>
          </div>
        )}
      </section>

      <ConnectWalletModal
        open={showConnectModal}
        handleClose={closeConnectWalletModal}
        onClickMetaMask={onClickMetaMask}
        onClickWalletConnect={onClickWalletConnect}
      />
      <ShareModal
        open={showShareModal}
        handleClose={closeShareModal}
        shareUrl={twitterImageUrl}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={accountConnected && !isValidNetwork}
        onClose={() => {}}
        message="Please switch to Ethereum Mainnet"
        // key={vertical + horizontal}
      />

      <div className={`${accountConnected == "" ? "" : "connected-wallet"}`}>
        <div className={isActive ? "open newLegendBlock" : "newLegendBlock"}>
          <img src={horizontalSvgLegendImage} />
          {/* <horizontalSvgLegendImage /> */}
          <p onClick={handleClick}>
            Legend{" "}
            <span>
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <polygon points="12 17.414 3.293 8.707 4.707 7.293 12 14.586 19.293 7.293 20.707 8.707 12 17.414" />
              </svg>{" "}
            </span>
          </p>
        </div>
        {/* <div class="theme-changer-box ">
          <div class="theme-changer">
            <div
              role="group"
              class="MuiToggleButtonGroup-root theme-btns"
              aria-label="text alignment"
            >
              <Button
                onClick={onClickLightTheme}
                variant="contained"
                class={`MuiButtonBase-root MuiToggleButton-root MuiToggleButtonGroup-grouped MuiToggleButtonGroup-groupedHorizontal ${
                  isLightTheme ? "selected" : "Mui-selected"
                }`}
                tabindex="0"
                type="button"
                value="light-theme"
                aria-pressed="false"
              >
                <span class="MuiToggleButton-label">
                  <i class="d-flex align-center justify-center ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      class="stroke-icon"
                    >
                      <path
                        d="M10 2.5V3.33333M10 16.6667V17.5M17.5 10H16.6667M3.33333 10H2.5M15.3033 15.3033L14.7141 14.7141M5.28596 5.28596L4.6967 4.6967M15.3033 4.69674L14.7141 5.286M5.286 14.7141L4.69674 15.3033M13.3333 10C13.3333 11.8409 11.8409 13.3333 10 13.3333C8.15905 13.3333 6.66667 11.8409 6.66667 10C6.66667 8.15905 8.15905 6.66667 10 6.66667C11.8409 6.66667 13.3333 8.15905 13.3333 10Z"
                        stroke="#8A92A7"
                        stroke-width="2"
                        stroke-linecap="round"
                      ></path>
                    </svg>
                  </i>
                  <span class="f-gibson fw-400 text-none">Light</span>
                </span>
                <span class="MuiTouchRipple-root"></span>
              </Button>
              <Button
                onClick={onClickDarkTheme}
                variant="contained"
                class={`MuiButtonBase-root MuiToggleButton-root MuiToggleButtonGroup-grouped MuiToggleButtonGroup-groupedHorizontal ${
                  !isLightTheme ? "selected" : "Mui-selected"
                }`}
                tabindex="0"
                type="button"
                value="dark-theme"
                aria-pressed="true"
              >
                <span class="MuiToggleButton-label">
                  <i class="d-flex align-center justify-center ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      class="stroke-icon"
                    >
                      <path
                        d="M15.7081 15.2544L16.4464 14.5687L15.4538 14.3954C12.166 13.8214 9.66667 10.9521 9.66667 7.50002C9.66667 6.09299 10.0841 4.75314 10.837 3.62315L11.3952 2.78552L10.3905 2.84683C6.63847 3.0758 3.66667 6.19067 3.66667 10C3.66667 13.9581 6.87529 17.1667 10.8333 17.1667C12.6792 17.1667 14.4059 16.4636 15.7081 15.2544ZM12.3597 2.85656C11.0762 4.04768 10.3333 5.71386 10.3333 7.50002C10.3333 10.9978 13.1689 13.8334 16.6667 13.8334C16.7978 13.8334 16.9284 13.8294 17.0585 13.8214C17.3334 13.8047 17.5089 14.1098 17.3561 14.339C15.9124 16.5052 13.4852 17.8334 10.8333 17.8334C6.5071 17.8334 3 14.3263 3 10C3 5.67379 6.5071 2.16669 10.8333 2.16669C11.2919 2.16669 11.7454 2.20612 12.1904 2.28386C12.4619 2.3313 12.5618 2.66906 12.3597 2.85656Z"
                        stroke="#8A92A7"
                      ></path>
                    </svg>
                  </i>
                  <span class="f-gibson fw-400 text-none">Dark</span>
                </span>
                <span class="MuiTouchRipple-root"></span>
              </Button>
            </div>
          </div>
        </div> */}
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"lg"}
        className="earth-model LegendModel"
      >
        <DialogTitle>
          Legend
          <Button onClick={handleClose} className="close-btn">
            {" "}
            <span>X</span>{" "}
          </Button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <figure className="Legendwrpper">
              <aside className="lighttheme-imgs">
                <img src={legendsimg1} class="img-responsive" />
                <img src={legendsimg2} class="img-responsive" />
                <img src={legendsimg3} class="img-responsive" />
              </aside>
              <aside className="darktheme-imgs">
                <img src={legendsDarkimg1} class="img-responsive" />
                <img src={legendsDarkimg2} class="img-responsive" />
                <img src={legendsDarkimg3} class="img-responsive" />
              </aside>
            </figure>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <footer className={`${accountConnected == "" ? "" : "connected"}`}>
        <div className="social-link-block">
          <a
            href="https://discord.com/invite/dotearth"
            target="_blank"
            title="discord"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M20.317 4.36979C18.761 3.65555 17.119 3.14623 15.4319 2.85459C15.4166 2.85173 15.4007 2.85378 15.3867 2.86044C15.3726 2.8671 15.3609 2.87803 15.3534 2.89169C15.1424 3.26699 14.9087 3.75649 14.7451 4.14119C12.9004 3.86499 11.0651 3.86499 9.2583 4.14119C9.0947 3.74789 8.8525 3.26699 8.6406 2.89169C8.63276 2.87835 8.62107 2.86768 8.60706 2.86108C8.59306 2.85448 8.57739 2.85225 8.5621 2.85469C6.87488 3.14566 5.2327 3.65493 3.6769 4.36969C3.66359 4.37538 3.65238 4.38506 3.6448 4.39739C0.533404 9.04579 -0.318996 13.5799 0.099204 18.0578C0.100386 18.0688 0.103757 18.0794 0.109116 18.089C0.114476 18.0986 0.121714 18.1071 0.130404 18.1139C2.1832 19.6215 4.1717 20.5367 6.1233 21.1433C6.13848 21.1478 6.15468 21.1476 6.16972 21.1427C6.18477 21.1377 6.19795 21.1283 6.2075 21.1157C6.6691 20.4853 7.0806 19.8205 7.4335 19.1215C7.43835 19.1119 7.44112 19.1014 7.44163 19.0907C7.44213 19.08 7.44036 19.0693 7.43643 19.0593C7.4325 19.0493 7.4265 19.0403 7.41883 19.0328C7.41115 19.0253 7.40198 19.0195 7.3919 19.0158C6.7391 18.7682 6.1176 18.4663 5.5197 18.1235C5.5088 18.1171 5.49964 18.1081 5.49304 18.0973C5.48643 18.0865 5.48258 18.0743 5.48183 18.0617C5.48108 18.049 5.48345 18.0364 5.48873 18.0249C5.49401 18.0135 5.50204 18.0034 5.5121 17.9958C5.6379 17.9015 5.7638 17.8035 5.8839 17.7044C5.89458 17.6956 5.9075 17.6899 5.92121 17.6881C5.93492 17.6862 5.94887 17.6882 5.9615 17.6939C9.8893 19.4872 14.1415 19.4872 18.0229 17.6939C18.0355 17.6879 18.0496 17.6856 18.0635 17.6873C18.0774 17.6889 18.0906 17.6945 18.1014 17.7034C18.2216 17.8024 18.3474 17.9015 18.4742 17.9958C18.4843 18.0034 18.4924 18.0133 18.4977 18.0247C18.5031 18.0362 18.5055 18.0487 18.5049 18.0613C18.5042 18.074 18.5005 18.0862 18.494 18.097C18.4875 18.1078 18.4784 18.1169 18.4676 18.1234C17.8695 18.4727 17.2429 18.7709 16.5946 19.0148C16.5845 19.0186 16.5754 19.0246 16.5678 19.0322C16.5602 19.0398 16.5542 19.049 16.5504 19.059C16.5466 19.0691 16.5449 19.0799 16.5455 19.0906C16.5461 19.1014 16.549 19.1119 16.5539 19.1215C16.9143 19.8195 17.3258 20.4843 17.7789 21.1147C17.7882 21.1277 17.8013 21.1375 17.8164 21.1426C17.8315 21.1477 17.8478 21.148 17.8631 21.1433C19.8241 20.5366 21.8126 19.6214 23.8654 18.1139C23.8742 18.1074 23.8816 18.0992 23.887 18.0897C23.8924 18.0801 23.8957 18.0696 23.8967 18.0587C24.3971 12.8817 23.0585 8.38479 20.3482 4.39829C20.3416 4.38534 20.3305 4.37519 20.317 4.36969V4.36979ZM8.02 15.3312C6.8375 15.3312 5.8631 14.2455 5.8631 12.9122C5.8631 11.579 6.8186 10.4933 8.0201 10.4933C9.2309 10.4933 10.1958 11.5885 10.1769 12.9123C10.1769 14.2455 9.2214 15.3312 8.02 15.3312V15.3312ZM15.9948 15.3312C14.8123 15.3312 13.8379 14.2455 13.8379 12.9122C13.8379 11.579 14.7933 10.4933 15.9948 10.4933C17.2056 10.4933 18.1705 11.5885 18.1516 12.9123C18.1516 14.2455 17.2056 15.3312 15.9948 15.3312V15.3312Z"
                  fill="#000000"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="24" height="24" fill="#000000" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a
            href="https://twitter.com/dotearth_"
            target="_blank"
            title="twitter"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M23.953 4.57003C23.0545 4.96563 22.1026 5.22677 21.128 5.34503C22.1541 4.72828 22.9224 3.76107 23.291 2.62203C22.34 3.17703 21.286 3.58103 20.164 3.80603C19.4238 3.01446 18.4429 2.48945 17.3736 2.31253C16.3044 2.13561 15.2067 2.31668 14.2509 2.82762C13.2952 3.33856 12.5349 4.15078 12.0881 5.13815C11.6412 6.12552 11.533 7.2328 11.78 8.28803C7.69 8.09503 4.067 6.13003 1.64 3.16203C1.19879 3.91184 0.968664 4.76705 0.974 5.63703C0.974 7.34703 1.844 8.85003 3.162 9.73303C2.38086 9.70816 1.61697 9.49696 0.934 9.11703V9.17703C0.933557 10.3134 1.32627 11.415 2.04551 12.2948C2.76474 13.1746 3.76621 13.7785 4.88 14.004C4.1583 14.1974 3.40241 14.2265 2.668 14.089C2.98412 15.067 3.59766 15.922 4.42301 16.5345C5.24837 17.1471 6.24435 17.4867 7.272 17.506C5.53153 18.872 3.38248 19.6133 1.17 19.611C0.78 19.611 0.391 19.588 0 19.544C2.25571 20.9884 4.87851 21.755 7.557 21.753C16.61 21.753 21.555 14.257 21.555 7.76803C21.555 7.55803 21.555 7.34803 21.54 7.13803C22.506 6.44289 23.3392 5.57985 24 4.59003L23.953 4.57003Z"
                fill="#000000"
              />
            </svg>
          </a>
          <a href="https://earth.domains/" target="_blank" title="twitter">
            <svg x="0px" y="0px" viewBox="0 0 491.52 491.52">
              <g>
                <g>
                  <path d="M344.995,123.16h-91.036v114.401h106.833C360.121,196.302,354.427,157.255,344.995,123.16z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M151.466,106.762h86.094V0.52C202.37,6.113,170.988,47.248,151.466,106.762z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M146.525,123.16c-9.432,34.095-15.127,73.142-15.797,114.401h106.833V123.16H146.525z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M253.959,0.52v106.242h86.094C320.532,47.248,289.151,6.113,253.959,0.52z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M114.329,253.959H0c1.371,41.553,13.086,80.511,32.666,114.409h96.343C120.145,334.208,114.94,295.441,114.329,253.959z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M299.86,5.861c24.2,21.254,44.352,56.478,58.022,100.901h90.663C413.979,56.49,361.229,19.695,299.86,5.861z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M32.661,123.161v-0.001C13.084,157.056,1.371,196.011,0,237.562h114.329c0.611-41.479,5.815-80.243,14.678-114.401H32.661    z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M377.191,253.959c-0.611,41.482-5.816,80.249-14.68,114.409h96.343c19.581-33.898,31.295-72.856,32.666-114.409H377.191z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M130.728,253.959c0.67,41.262,6.366,80.312,15.799,114.409h91.033V253.959H130.728z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M133.64,384.766H42.98c34.568,50.269,87.315,87.061,148.68,100.894C167.462,464.407,147.31,429.186,133.64,384.766z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M357.88,384.766c-13.67,44.42-33.821,79.642-58.019,100.894c61.366-13.832,114.113-50.625,148.68-100.894H357.88z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M42.975,106.762h90.663c13.67-44.423,33.821-79.647,58.022-100.901C130.291,19.695,77.542,56.49,42.975,106.762z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M253.959,384.766V491c35.191-5.593,66.571-46.724,86.092-106.234H253.959z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M151.469,384.766c19.522,59.51,50.902,100.642,86.092,106.234V384.766H151.469z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M253.959,253.959v114.409h91.034c9.433-34.097,15.128-73.147,15.799-114.409H253.959z" />
                </g>
              </g>
              <g>
                <g>
                  <path d="M458.858,123.16h-96.346c8.863,34.158,14.067,72.922,14.678,114.401h114.33    C490.149,196.011,478.436,157.056,458.858,123.16z" />
                </g>
              </g>
            </svg>
          </a>

          {/* <a
            href="https://goerli.etherscan.io/address/0xdf71ca1bcdd748901c70ab3602f9c91b92ee8fbe"
            target="_blank"
            title="goerli"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M5.57066 11.4699C5.57064 11.347 5.59489 11.2254 5.64201 11.112C5.68913 10.9986 5.7582 10.8956 5.84524 10.8089C5.93229 10.7222 6.0356 10.6536 6.14924 10.607C6.26288 10.5604 6.3846 10.5367 6.50743 10.5373L8.0605 10.5424C8.30813 10.5424 8.54562 10.6408 8.72072 10.8159C8.89583 10.991 8.9942 11.2284 8.9942 11.4761V17.3488C9.16915 17.297 9.39353 17.2417 9.63933 17.184C9.81 17.1439 9.9621 17.0472 10.071 16.9098C10.1799 16.7724 10.2391 16.6022 10.2392 16.4268V9.14223C10.2392 8.89457 10.3375 8.65705 10.5126 8.48191C10.6877 8.30676 10.9252 8.20835 11.1729 8.20831H12.7291C12.9767 8.20837 13.2142 8.30679 13.3893 8.48193C13.5644 8.65707 13.6628 8.89458 13.6628 9.14223V15.9033C13.6628 15.9033 14.0522 15.7456 14.4319 15.5854C14.5728 15.5258 14.6931 15.426 14.7777 15.2984C14.8624 15.1709 14.9075 15.0212 14.9077 14.8682V6.80757C14.9077 6.68497 14.9318 6.56356 14.9787 6.45029C15.0256 6.33701 15.0944 6.23408 15.1811 6.14738C15.2678 6.06068 15.3707 5.9919 15.4839 5.94497C15.5972 5.89804 15.7186 5.87388 15.8412 5.87387H17.3974C17.6451 5.87387 17.8826 5.97224 18.0577 6.14734C18.2328 6.32244 18.3312 6.55993 18.3312 6.80757V13.445C19.6803 12.4673 21.0477 11.2912 22.1327 9.87716C22.2902 9.6719 22.3943 9.43086 22.436 9.17555C22.4776 8.92024 22.4554 8.6586 22.3713 8.41397C21.6371 6.27435 20.26 4.41372 18.4282 3.08649C16.5964 1.75926 14.3994 1.03021 12.1375 0.999044C6.03822 0.91711 0.997501 5.89597 0.9981 11.996C0.992111 13.9262 1.4959 15.8238 2.45853 17.4969C2.59128 17.7258 2.78658 17.912 3.02149 18.0337C3.2564 18.1554 3.52116 18.2075 3.78467 18.1839C4.07908 18.158 4.44561 18.1214 4.88134 18.0702C5.07099 18.0487 5.24609 17.9581 5.37327 17.8157C5.50045 17.6734 5.57084 17.4893 5.57103 17.2984V11.4699"
                fill="#000000"
              />
              <path
                d="M5.53719 20.8877C7.1775 22.081 9.11595 22.7973 11.1381 22.9573C13.1602 23.1173 15.1872 22.7147 16.9947 21.7943C18.8023 20.8738 20.32 19.4712 21.3799 17.7417C22.4398 16.0122 23.0006 14.0232 23.0003 11.9948C23.0003 11.7416 22.9886 11.4912 22.9716 11.2422C18.9542 17.2337 11.5364 20.0351 5.53711 20.8879"
                fill="#000000"
              />
            </svg>
          </a>
          <a href="https://opensea.io" target="_blank" title="opensea">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M11.5 3C6.2541 3 2 7.2541 2 12.5C2 17.7459 6.2541 22 11.5 22C16.7459 22 21 17.7459 21 12.5C21 7.2541 16.7478 3 11.5 3ZM6.6873 12.8192L6.7272 12.7546L9.1991 8.8881C9.2352 8.833 9.3207 8.8387 9.3473 8.8995C9.7596 9.8248 10.1168 10.9762 9.9496 11.6925C9.8793 11.987 9.6836 12.386 9.4632 12.7546C9.4347 12.8078 9.4043 12.861 9.3701 12.9123C9.3549 12.9351 9.3283 12.9484 9.2998 12.9484H6.7595C6.6911 12.9484 6.6512 12.8743 6.6873 12.8192ZM17.7016 14.1492C17.7016 14.1853 17.6807 14.2157 17.6503 14.229C17.4584 14.3107 16.8029 14.6128 16.5312 14.9909C15.8358 15.958 15.3057 17.3412 14.1182 17.3412H9.1668C7.4112 17.3412 5.99 15.9143 5.99 14.153V14.096C5.99 14.0504 6.028 14.0124 6.0755 14.0124H8.8343C8.8894 14.0124 8.9293 14.0618 8.9255 14.1169C8.9046 14.2955 8.9388 14.4798 9.0243 14.647C9.1877 14.9795 9.5278 15.1866 9.8945 15.1866H11.2606V14.1207H9.9097C9.8413 14.1207 9.7995 14.0409 9.8394 13.9839C9.8546 13.9611 9.8698 13.9383 9.8888 13.9117C10.0161 13.7293 10.1985 13.4481 10.3809 13.127C10.5044 12.9104 10.6241 12.6786 10.721 12.4468C10.74 12.405 10.7552 12.3613 10.7723 12.3195C10.7989 12.2454 10.8255 12.1751 10.8445 12.1067C10.8635 12.0478 10.8806 11.987 10.8958 11.93C10.9414 11.7324 10.9604 11.5234 10.9604 11.3068C10.9604 11.2213 10.9566 11.132 10.949 11.0484C10.9452 10.9553 10.9338 10.8622 10.9224 10.7691C10.9148 10.6874 10.8996 10.6057 10.8844 10.5221C10.8635 10.3986 10.8369 10.2751 10.8065 10.1516L10.7951 10.1041C10.7723 10.0186 10.7514 9.9388 10.7248 9.8533C10.6469 9.5873 10.5595 9.327 10.4645 9.0838C10.4303 8.9869 10.3923 8.8938 10.3524 8.8026C10.2954 8.662 10.2365 8.5347 10.1833 8.415C10.1548 8.3599 10.132 8.3105 10.1092 8.2592C10.0826 8.2022 10.056 8.1452 10.0275 8.0901C10.0085 8.0483 9.9857 8.0084 9.9705 7.9704L9.8033 7.6626C9.7805 7.6208 9.8185 7.5695 9.8641 7.5828L10.9091 7.8659H10.9129C10.9148 7.8659 10.9148 7.8659 10.9167 7.8659L11.0535 7.9058L11.2055 7.9476L11.2606 7.9628V7.3434C11.2606 7.0432 11.5 6.8 11.7983 6.8C11.9465 6.8 12.0814 6.8608 12.1764 6.9596C12.2733 7.0584 12.3341 7.1933 12.3341 7.3434V8.2649L12.4462 8.2953C12.4538 8.2991 12.4633 8.3029 12.4709 8.3086C12.4975 8.3276 12.5374 8.358 12.5868 8.396C12.6267 8.4264 12.6685 8.4644 12.7179 8.5043C12.8186 8.586 12.9402 8.6905 13.0713 8.8102C13.1055 8.8406 13.1397 8.871 13.172 8.9033C13.3411 9.061 13.5311 9.2453 13.7135 9.4505C13.7648 9.5094 13.8142 9.5664 13.8655 9.6291C13.9149 9.6918 13.97 9.7526 14.0156 9.8134C14.0783 9.8951 14.1429 9.9806 14.2018 10.0699C14.2284 10.1117 14.2607 10.1554 14.2854 10.1972C14.3614 10.3093 14.426 10.4252 14.4887 10.5411C14.5153 10.5943 14.5419 10.6532 14.5647 10.7102C14.635 10.866 14.6901 11.0237 14.7243 11.1833C14.7357 11.2175 14.7433 11.2536 14.7471 11.2878V11.2954C14.7585 11.341 14.7623 11.3904 14.7661 11.4417C14.7813 11.6032 14.7737 11.7666 14.7395 11.93C14.7243 11.9984 14.7053 12.063 14.6825 12.1333C14.6578 12.1998 14.635 12.2682 14.6046 12.3347C14.5457 12.4696 14.4773 12.6064 14.3956 12.7318C14.369 12.7793 14.3367 12.8287 14.3063 12.8762C14.2721 12.9256 14.236 12.9731 14.2056 13.0187C14.1619 13.0776 14.1163 13.1384 14.0688 13.1935C14.027 13.2505 13.9852 13.3075 13.9377 13.3588C13.8731 13.4367 13.8104 13.5089 13.7439 13.5792C13.7059 13.6248 13.6641 13.6723 13.6204 13.7141C13.5786 13.7616 13.5349 13.8034 13.4969 13.8414C13.4304 13.9079 13.3772 13.9573 13.3316 14.001L13.2233 14.0979C13.2081 14.1131 13.1872 14.1207 13.1663 14.1207H12.3341V15.1866H13.381C13.6147 15.1866 13.837 15.1049 14.0175 14.951C14.0783 14.8978 14.3462 14.666 14.6635 14.3164C14.6749 14.3031 14.6882 14.2955 14.7034 14.2917L17.5933 13.4557C17.6484 13.4405 17.7016 13.4804 17.7016 13.5374V14.1492Z"
                fill="#000000"
              />
            </svg>
          </a>
          <a href="https://looksrare.org/" target="_blank" title="opensea">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="148"
              height="148"
              viewBox="0 0 148 148"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M74 86C61.3026 86 51 75.7077 51 63C51 50.2923 61.3026 40 74 40C86.6974 40 97 50.2923 97 63C97 75.7077 86.6974 86 74 86ZM64 63C64 68.5251 68.4794 73 74 73C79.5206 73 84 68.5251 84 63C84 57.4749 79.5206 53 74 53C68.4794 53 64 57.4749 64 63Z"
                fill="#000000"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 63.0304L44 19H104L148 63.0304L74 137L0 63.0304ZM108 46.9998C89.3047 28.2224 58.6953 28.2225 40 46.9999L24 63.0001L40 79.0002C58.6953 97.7776 89.3047 97.7775 108 79.0001L124 63.0001L108 46.9998Z"
                fill="#000000"
              />
            </svg>
          </a> */}
        </div>

        {/* <ul>
          <li>
            <a onClick={handleClickOpen}>
              
              To know about legends click here.
            </a>
          </li>
          </ul> */}
        {/* <ul>
          <li>
            <a onClick={handleClickOpen}>
             
              To know about legends click here.
            </a>
          </li> */}
        {/* <li>
            <a>
              {" "}
              <span
                className="yellow"
                style={{ background: "yellow" }}
              ></span>{" "}
              Transaction Out
            </a>
          </li>
          <li>
            <a>
              {" "}
              <span className="red" style={{ background: "red" }}></span>{" "}
              Balance
            </a>
          </li>
          <li>
            <a>
              {" "}
              <span
                className="lightgray"
                style={{ background: "lightgray" }}
              ></span>{" "}
              NFT
            </a>
          </li>
          <li>
            <a>
              {" "}
              <span
                className="green"
                style={{ background: "green" }}
              ></span>{" "}
              DEFI
            </a>
          </li>
          <li>
            <a>
              {" "}
              <span
                className="black"
                style={{ background: "#00bcd4" }}
              ></span>{" "}
              NA
            </a>
          </li> */}
        {/* </ul> */}
        {/* <p>
          Presented by{" "}
          <a href="#" target="_blank">
            {" "}
            Earth Labs
          </a>
        </p> */}
      </footer>
    </React.Fragment>
  );
};

export default DashboardContainer;
